import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function TermsOfService() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const backgroundImage = isMobile
    ? "https://geneartai.com/images/mobile1.png"
    : "https://geneartai.com/images/image1.png";

  return (
    <div className="relative min-h-screen font-sans text-white overflow-x-hidden">

      {/* Responsive Background */}
      <div
        className="fixed inset-0 bg-cover bg-center z-0"
        style={{
          backgroundImage: `url('${backgroundImage}')`,
          backgroundAttachment: isMobile ? "scroll" : "fixed",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0"></div>
      </div>

      {/* Foreground Content */}
      <div className="relative z-10 flex flex-col min-h-screen">

        {/* Top Spacer for Navbar */}
        <div className="pt-28" />

        {/* Main Content */}
        <div className="flex-grow p-6">
          <div className="max-w-4xl mx-auto bg-black/50 text-white p-8 rounded-2xl shadow-2xl backdrop-blur-md">
            <h1 className="text-3xl font-extrabold mb-6 text-center">
              Terms of Service
            </h1>

            <p className="mb-4">
              Welcome to <strong>GeneArtAI</strong> ("we", "our", "us"). These Terms of Service ("Terms") govern your access and use of our website at <strong>https://geneartai.com</strong>.
            </p>

            <h2 className="text-2xl font-bold mt-6 mb-2">1. Acceptance of Terms</h2>
            <p className="mb-4">
              By accessing or using GeneArtAI, you agree to be bound by these Terms. If you do not agree to all the terms, please do not use our service.
            </p>

            <h2 className="text-2xl font-bold mt-6 mb-2">2. Use of the Service</h2>
            <p className="mb-4">
              GeneArtAI provides AI-based image generation services. You may use the service for personal or commercial purposes subject to these Terms and applicable laws.
            </p>

            <h2 className="text-2xl font-bold mt-6 mb-2">3. User Content</h2>
            <p className="mb-4">
              You are responsible for any content (prompts, images) you create or submit. You must not upload offensive, illegal, or copyrighted material without permission.
            </p>

            <h2 className="text-2xl font-bold mt-6 mb-2">4. Intellectual Property</h2>
            <p className="mb-4">
              GeneArtAI and its logo are our property. AI-generated images may be used freely by the user, subject to third-party model license terms.
            </p>

            <h2 className="text-2xl font-bold mt-6 mb-2">5. Limitation of Liability</h2>
            <p className="mb-4">
              GeneArtAI is provided "as is" without warranties of any kind. We are not responsible for any damages or losses resulting from use of the service.
            </p>

            <h2 className="text-2xl font-bold mt-6 mb-2">6. Modifications to Service</h2>
            <p className="mb-4">
              We may update, suspend, or discontinue any part of the service at any time without prior notice.
            </p>

            <h2 className="text-2xl font-bold mt-6 mb-2">7. Termination</h2>
            <p className="mb-4">
              We may terminate or suspend your access to GeneArtAI immediately if you breach these Terms.
            </p>

            <h2 className="text-2xl font-bold mt-6 mb-2">8. Governing Law</h2>
            <p className="mb-4">
              These Terms are governed by the laws of Australia, without regard to its conflict of law principles.
            </p>

            <h2 className="text-2xl font-bold mt-6 mb-2">9. Contact Us</h2>
            <p className="mb-4">
              For any questions about these Terms, please contact us at:
              <br />
              <strong>Email:</strong> support@geneartai.com
            </p>

            <p className="text-xs mt-8 text-center text-gray-400">
              Last Updated: April 2025
            </p>
          </div>
        </div>

        {/* Footer */}
        <footer className="text-center text-xs text-gray-300 pb-3">
          <div>© 2025 GeneArtAI — All Rights Reserved.</div>
          <div className="mt-2">
            <Link to="/privacy-policy" className="text-gray-300 hover:text-white underline">
              Privacy Policy
            </Link>{" "}
            |{" "}
            <Link to="/terms-of-service" className="underline hover:text-white">
              Terms of Service
            </Link>
          </div>
        </footer>

        {/* Mobile Bottom Spacer */}
        <div className="block sm:hidden h-20" />
      </div>
    </div>
  );
}
